import React from 'react';

import { PackageIntlProvider } from '../../../intl-provider';
import { DEFAULT_LOCALE } from '../../../intl-provider/ProFormaIntlProvider';
import { NoticeDialog } from './NoticeDialog';
import { Notices, type NoticeType } from './noticeTypes';

export interface IntlValues {
	titleVars?: { [varName: string]: string };
	msgVars?: { [varName: string]: string };
}

export interface NoticeSettings {
	customLocale?: string;
	intlValues?: IntlValues;
	errorDetails?: string;
	overrideZIndex?: boolean;
}

interface NoticeComponentProps {
	noticeType: NoticeType;
	handleClose: (confirmed?: boolean) => void;
	settings: NoticeSettings;
}

export const Notice: React.FC<NoticeComponentProps> = ({
	noticeType,
	handleClose,
	settings: { customLocale = DEFAULT_LOCALE, intlValues, errorDetails, overrideZIndex },
}) => {
	const notice = Notices[noticeType];

	if (!notice) {
		// eslint-disable-next-line no-console
		console.error(`Could not show notice, notice type ${noticeType} does not exist`);
		handleClose();
	}

	return (
		<PackageIntlProvider locale={customLocale}>
			<NoticeDialog
				title={notice.title}
				titleVars={intlValues?.titleVars}
				message={notice.message}
				messageVars={intlValues?.msgVars}
				confirmText={notice.confirmText}
				confirmLink={notice.confirmLink}
				handleClose={handleClose}
				isErrorNotice={notice.isErrorNotice}
				errorDetails={errorDetails}
				isWarningNotice={notice.isWarningNotice}
				overrideZIndex={overrideZIndex}
			/>
		</PackageIntlProvider>
	);
};
